import React, { lazy, Suspense, memo } from "react";
import { useSelector } from "react-redux";
import Loading from "components/shared-components/Loading";
import Views from "views";
import useBackgroundLocation from "utils/hooks/useBackgroundLocation";
import { useLocation, matchRoutes } from "react-router-dom";
import { PUBLICROUTES } from "routes/PublicRoute";
import {
  protectedRoutes,
  publicRoutes,
  publicShareRoute,
} from "configs/RoutesConfig";

const AppLayout = lazy(() => import("./AppLayout"));
const AuthLayout = lazy(() => import("./AuthLayout"));

const ALL_ROUTES = [
  ...protectedRoutes,
  ...publicRoutes,
  ...publicShareRoute,
];

const Layouts = () => {
  const token = useSelector((state) => state.auth.token);
  const location = useLocation();
  // Chat mo dang modal -> layout bam theo trang nen, khong theo URL /app/chat-erp.
  const { pathname } = useBackgroundLocation() || location;
  const matched = matchRoutes(ALL_ROUTES, pathname);
  const routeBlankLayout = Boolean(matched?.[0]?.route?.meta?.blankLayout);
  const Layout =
    token && !routeBlankLayout && !PUBLICROUTES.includes(pathname)
      ? AppLayout
      : AuthLayout;
  return (
    <Suspense fallback={<Loading cover="content" />}>
      <Layout>
        <Views />
      </Layout>
    </Suspense>
  );
};

export default memo(Layouts);
